// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__h8S69","footer":"ChangeClinic_footer__22Ofy"};